import { RestaurantPromotionType, type RestaurantPromotion } from "@/API";
import { clsx, type ClassValue } from "clsx";
import type { TFunction } from "i18next";
import mixpanel from "mixpanel-browser";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatPromotionToText = (
  promo: RestaurantPromotion,
  t: TFunction<"translation", undefined>,
): string => {
  if (promo.type === RestaurantPromotionType.ItemPercentOff)
    return t("promotion_item_percent_off", { discount: promo.discount });
  if (promo.type === RestaurantPromotionType.BuyXGetYFree)
    return t("promotion_buy_x_get_y_free", {
      buyCount: promo.buyCount,
      freeCount: promo.freeCount,
    });
  if (promo.type === RestaurantPromotionType.MenuPercentOff)
    return t("promotion_menu_percent_off", {
      discount: promo.discount,
      minValue: promo?.minValue ? promo?.minValue / 100 : "N/A",
    });
  if (
    promo.type === RestaurantPromotionType.FreeDelivery &&
    promo?.minValue === 0
  )
    return t("promotion_free_delivery");
  if (promo.type === RestaurantPromotionType.FreeDelivery)
    return t("promotion_free_delivery_with_min_value", {
      minValue: promo?.minValue ? promo?.minValue / 100 : "N/A",
    });
  if (promo.type === RestaurantPromotionType.FreeItem)
    return t("promotion_free_item", {
      minValue: promo?.minValue ? promo?.minValue / 100 : "N/A",
    });
  return JSON.stringify(promo.type);
};

export const getColorKrunshScore = (value: number): string => {
  if (value < 40) return "#E2483D";
  if (value < 80) return "#E56910";
  return "#00A408";
};

export const triggerEvent = (evenName: string, eventParams?: object) => {
  mixpanel.track(evenName, eventParams);
  // @ts-ignore
  cioanalytics.track(evenName, eventParams);
};

export const getUserPosition = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        return { lat: latitude, lng: longitude };
      },
      (error) => {
        console.error("Erreur:", error.message);
      },
      {
        maximumAge: 0,
      },
    );
  } else {
    console.log("geolocation not available");
  }
  return { lat: 48.858374, lng: 2.336046 };
};

export const formatPrice = (price: string): string => {
  if (price === "0") return "0";

  const splitSprice = price.split(".");
  const leftPart = splitSprice[0];
  const sizeOfTheLeftPart = leftPart.length / 3;

  const newPricePerPart = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < sizeOfTheLeftPart; i++) {
    const firstParamToSplit = (i + 1) * 3;
    const secondParamToSplit = i * 3;

    if (secondParamToSplit === 0) {
      newPricePerPart.unshift(leftPart.slice(-firstParamToSplit));
    } else {
      newPricePerPart.unshift(
        leftPart.slice(-firstParamToSplit, -secondParamToSplit),
      );
    }
  }

  const newLeftPart = newPricePerPart.join(",");

  if (splitSprice[1]) {
    return `${newLeftPart}.${splitSprice[1]}`;
  }

  return newLeftPart;
};

export const download = (content: string, fileName: string): void => {
  const encodedUri = encodeURI(content);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(encodedUri);
};
